export const AWARDS_CATEGORY_KEY = 'overview' as const;
export const AWARDS_COMPONENT_KEY = 'awards' as const;
